import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import '../../css/pages/recover-password-form/recover-password-form.scss';

class RecoverPassword {
  constructor() {}

  public init(): void {
    this.bindEvents();
  }

  private bindEvents(): void {}
}

registerPageInit('recover-password-form', () => {
  const page = new RecoverPassword();
  page.init();
});
